import { createTypes } from 'redux-create-types';
import { fromType, } from 'kreighter';

const namespace = 'quiz';

export const quizActions = createTypes([
    'saveQuiz',
    'removeQuiz',
    'saveOverview',
    'setQuizProgress',
    'clearOverviews'
], namespace);

export const quizActionsCreators = {
    saveQuiz: fromType(quizActions.saveQuiz, ['quiz']),
    removeQuiz: fromType(quizActions.removeQuiz, ['id']),
    setQuizProgress: fromType(quizActions.setQuizProgress, ['id', 'grade', 'correctCount', 'wrongCount', 'notAnsweredCount']),
    saveOverview: fromType(quizActions.saveOverview, ['overview', 'courseId']),
    clearOverviews: fromType(quizActions.clearOverviews, []),
}